import { render, staticRenderFns } from "./PermissionDrawer.vue?vue&type=template&id=a33f3c36&scoped=true"
import script from "./PermissionDrawer.vue?vue&type=script&lang=js"
export * from "./PermissionDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a33f3c36",
  null
  
)

export default component.exports